'use strict'

{ cllCookie, getSearchLocCookie, setSearchLocCookie, setELLCookie } = require './m_location_helper'
ClosestDivision = require '../common/m_closest_division.coffee'
tracky = require '../../general/m_trackEvent'
successCallback = errorCallback = intervalID = undefined
FIVE_MINUTES_IN_MS = 1000 * 60 * 5

TEN_YEARS_IN_MS = 1000 * 60 * 60 * 24 * 365 * 10

###*
# HTML5 Geolocation API success callback
#
# @callback success
# @param   {Object}   position        - Position information returned by Geolocation API
# @returns {function} successCallBack - Callback to proceed in the search form submit
###
success = (position) ->
  {latitude: lat, longitude: lng} = position?.coords
  # Limit lat/lng to 3 decimal
  lat = parseFloat(lat.toFixed(3))
  lng = parseFloat(lng.toFixed(3))
  Groupon.Utils.trackEvent 'client-geolocate-successful', {lat, lng}
  clearInterval(intervalID) if intervalID
  intervalID = setInterval updateCurrentLocation, FIVE_MINUTES_IN_MS
  cllCookie.set(position)
  successCallback?({lat, lng, current: true})

###*
# HTML5 Geolocation API error callback
#
# @callback error
# @param   {Object}   err           - Error object returned by Geolocation API
# @returns {Function} errorCallback - Callback to exit search form submit
###
error = (err) ->
  Groupon.Utils.trackEvent 'client-geolocate-failed', err
  cllCookie.remove(err)
  errorCallback?(err)

###*
# Function to initialize timer and set Location
###

initCllTimer = ->
  cll = Cookie.get('cll')
  ell = Cookie.get('ell')
  setLocationTracky(cll, ell)
  setCLLTimer(cll)

###*
# Function to set the timer for CLL
###

setCLLTimer = (cll) ->
  return unless cll?

  currentTime = Date.now()

  TTL = localStorage?.getItem('cll_TTL') or Cookie.get('cll_TTL') or currentTime

  if currentTime >= TTL
    updateCurrentLocation()
  else
    setTimeout updateCurrentLocation, TTL - currentTime

###*
# Function to set tracky event for cll and ell being equal
###

setLocationTracky = (cll, ell) ->
  return unless isCurrentLocationSet()

  tracky 'sls-current-location-cookies', {
    ell: ell
    cll: cll
    divisioins: Cookie.get('division')
    in_sync: cll is ell
  }

###*
# Getter function for current location
###

isCurrentLocationSet = ->
  nearMeTranslation = Groupon.LS?.translations?.search?.nearme
  getSearchLocCookie()?.friendlyName is nearMeTranslation

###*
# Function to keep location user updated when they are in "Current location"
###

updateCurrentLocation = ->
  search_loc = getSearchLocCookie()
  updateLocationCookies = Groupon.LS?.flags?.updateLocationCookies or false

  isCurrentLocation = isCurrentLocationSet()

  if updateLocationCookies and isCurrentLocation
    detectCurrentLocation ({lat, lng}) ->
      updateCookies = ({divisionId}) ->
        # Update search_loc cookie
        Object.assign search_loc, {
          lat
          lng
          closestDivision: divisionId
          currentLocation: true
        }

        setSearchLocCookie search_loc

        # Update division cookie. Using Cookie.set to keep consistency with
        # current behaviour (using non-specific domain)
        Cookie.set 'division', divisionId, { maxAge: TEN_YEARS_IN_MS, consentClass: 'essential' }

        # Update ell cookie
        setELLCookie(lat + ',' + lng)

      # Get closest division
      ClosestDivision.getClosestDivision {
        loc: ''
        lat
        lng
        success: updateCookies
        error: -> # Do not update the cookies if we can't get closest division
      }

  else
    detectCurrentLocation()

###*
# Function to determine parameters for HTML5 Geolocation API
#
# @param {Object}   [positionOptions] - Configuration  of Geolocation API (Optional)
# @param {Function} [successCB]       - Callback for successful geolocation (Optional)
# @param {Function} [errorCB]         - Callback for failed geolocation (Optional)
###
checkCurrentLocation = (positionOptions = {}, successCB = cllCookie.set, errorCB = cllCookie.remove) ->
  option = Object.assign({ timeout: 10000 }, positionOptions)
  navigator.geolocation.getCurrentPosition(successCB, errorCB, option)

###*
# Function to determine parameters for HTML5 Geolocation API
#
# @param {Function[]} arg                   - Splat of arguments containing success and error function
# @param {Function}   arg[].successCallback - Callback for successful geolocation (Optional)
# @param {Function}   arg[].errorCB         - Callback for failed geolocation (Optional)
###
detectCurrentLocation = (arg...) ->
  [successCallback, errorCallback] = arg
  return errorCallback?() unless navigator.geolocation
  positionOptions = Groupon.LS.options?.geolocationOptions or {}

  checkCurrentLocation(positionOptions, success, error)


# Groupon.Utils.detectCurrentLocation:
module.exports = {
  checkCurrentLocation
  currentLocationSuccess: success
  currentLocationError: error
  detectCurrentLocation
  setCLLTimer
  initCllTimer
}
